import { cva } from 'class-variance-authority'

import { BadgeVariant } from '../types'

/** Section (icon) sizing for default badges - 12px */
export const sectionSizeClasses = '[&>svg]:size-3'

/** Section (icon) sizing for status badges - 14px */
export const statusSectionSizeClasses = '[&>svg]:size-3.5'

const sharedBaseClasses = [
  // Layout
  'inline-flex items-center justify-center gap-1',
  // Width/overflow
  'w-fit whitespace-nowrap shrink-0 overflow-hidden',
  // Icon-only: square aspect ratio when no text label is present
  '[&:not(:has([data-label]))]:aspect-square [&:not(:has([data-label]))]:px-0',
  // Transition
  'transition-colors',
]

export const badgeVariants = cva(
  [
    ...sharedBaseClasses,
    // Size
    'px-[5px] py-[1.5px] h-5',
    // Border
    'border',
    // Border radius
    'rounded-md',
  ],
  {
    defaultVariants: {
      variant: BadgeVariant.Neutral,
    },
    variants: {
      variant: {
        [BadgeVariant.Neutral]:
          'bg-surface-badge-neutral text-text-neutral border-border-neutral',
        [BadgeVariant.Processing]:
          'bg-surface-badge-processing text-text-processing border-border-processing',
        [BadgeVariant.Success]:
          'bg-surface-badge-success text-text-success border-border-success',
        [BadgeVariant.Warning]:
          'bg-surface-badge-warning text-text-warning border-border-warning',
        [BadgeVariant.Danger]:
          'bg-surface-badge-danger text-text-danger border-border-danger',
        [BadgeVariant.Special]:
          'bg-surface-badge-special text-text-special border-border-special',
      },
    },
  },
)

/** Weak icon colors for status badge icon sections */
export const statusIconColorClasses: Record<BadgeVariant, string> = {
  [BadgeVariant.Neutral]: 'text-icon-neutral-weak',
  [BadgeVariant.Processing]: 'text-icon-processing-weak',
  [BadgeVariant.Success]: 'text-icon-success-weak',
  [BadgeVariant.Warning]: 'text-icon-warning-weak',
  [BadgeVariant.Danger]: 'text-icon-danger-weak',
  [BadgeVariant.Special]: 'text-icon-special-weak',
}

export const statusBadgeVariants = cva(
  [
    ...sharedBaseClasses,
    // Size
    'pl-1 pr-1.5 py-0.5',
    // Without a left icon there is nothing to absorb the tighter left padding.
    '[&:not(:has([data-section]))]:pl-1.5',
    // Icon-only squares match a labelled badge's height.
    '[&:not(:has([data-label]))]:size-5',
    // Border radius
    'rounded-sm',
  ],
  {
    defaultVariants: {
      variant: BadgeVariant.Neutral,
    },
    variants: {
      variant: {
        [BadgeVariant.Neutral]:
          'bg-surface-badge-neutral-weak text-text-neutral',
        [BadgeVariant.Processing]:
          'bg-surface-badge-processing-weak text-text-processing',
        [BadgeVariant.Success]:
          'bg-surface-badge-success-weak text-text-success',
        [BadgeVariant.Warning]:
          'bg-surface-badge-warning-weak text-text-warning',
        [BadgeVariant.Danger]: 'bg-surface-badge-danger-weak text-text-danger',
        [BadgeVariant.Special]:
          'bg-surface-badge-special-weak text-text-special',
      },
    },
  },
)
